import React from "react";

import {
  Box,
  Typography,
  Paper,
  TextField,
  InputAdornment,
  Button,
  MenuItem,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";

import "./filterBar.css";

interface Props {
  title?: string;

  search?: string;
  onSearchChange?: (val: string) => void;

  status?: string;
  onStatusChange?: (val: string) => void;

  showStatus?: boolean;

  actionButtonText?: string;
  onActionClick?: () => void;

  // 🔥 QUICK FILTER
  quickFilter?: string;
  onQuickFilterChange?: (val: string) => void;
}

const FilterBar: React.FC<Props> = ({
  title = "Manage Data",

  search,
  onSearchChange,

  status,
  onStatusChange,

  showStatus = true,

  actionButtonText,
  onActionClick,

  quickFilter,
  onQuickFilterChange,
}) => {
  return (
    <Paper className="filter-bar">
      {/* HEADER */}

      <Typography className="filter-title">{title}</Typography>

      {/* MAIN ROW */}

      <Box className="filter-row">
        {/* LEFT SIDE */}

        <Box className="filter-left">
          {/* SEARCH */}

          <TextField
            size="small"
            placeholder="Search by Lead ID, Name, Mobile..."
            value={search}
            onChange={(e) => onSearchChange?.(e.target.value)}
            className="filter-input"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon
                      sx={{
                        color: "#94a3b8",
                      }}
                    />
                  </InputAdornment>
                ),
              },
            }}
          />

          {/* STATUS */}

          {showStatus && (
            <TextField
              select
              size="small"
              value={status || ""}
              onChange={(e) => onStatusChange?.(e.target.value)}
              className="filter-input"
              slotProps={{
                select: {
                  displayEmpty: true,

                  renderValue: (selected: unknown) => {
                    const value = selected as string;

                    if (!value) {
                      return "All Status";
                    }

                    return value.charAt(0).toUpperCase() + value.slice(1);
                  },
                },
              }}
            >
              <MenuItem value="">All Status</MenuItem>

              <MenuItem value="login">Login</MenuItem>

              <MenuItem value="pending">Pending</MenuItem>

              <MenuItem value="credit">Credit</MenuItem>

              <MenuItem value="approved">Approved</MenuItem>

              <MenuItem value="disbursed">Disbursed</MenuItem>
            </TextField>
          )}
        </Box>

        {/* RIGHT SIDE */}

        <Box className="filter-right">
          {/* QUICK FILTERS */}

          {onQuickFilterChange && (
            <Box className="quick-filters">
              {["today", "week", "month", "year"].map((item) => (
                <Button
                  key={item}
                  size="small"
                  variant={quickFilter === item ? "contained" : "outlined"}
                  className={`quick-btn ${
                    quickFilter === item ? "active" : ""
                  }`}
                  onClick={() => onQuickFilterChange?.(item)}
                >
                  {item.charAt(0).toUpperCase() + item.slice(1)}
                </Button>
              ))}
            </Box>
          )}

          {/* ACTION BUTTON */}

          {actionButtonText && (
            <Button
              variant="contained"
              onClick={onActionClick}
              className="filter-btn"
            >
              {actionButtonText}
            </Button>
          )}
        </Box>
      </Box>
    </Paper>
  );
};

export default FilterBar;
